import {findRangeFromProductCode} from "./findRangeFromProductCode";

export default {
    findRangeFromProductCode
}